import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { QueryResponseCache as RelayQueryResponseCache, stableCopy } from 'relay-runtime';
export function getCacheKey(queryID, variables) {
  return JSON.stringify(stableCopy({
    queryID: queryID,
    variables: variables
  }));
}
export function getQueryIDFromCacheKey(cacheKey) {
  return JSON.parse(cacheKey).queryID;
}

/**
 * Query response cache that works across SSR. Extends on Relay's QueryResponse Cache:
 * https://github.com/facebook/relay/blob/main/packages/relay-runtime/network/RelayQueryResponseCache.js
 *
 * Can properly handle multiple requests of the same ID (Relay's Cache ID is based on query, not variables),
 * and includes a TTL and maximum cache size to further prevent stale data.
 */
export var SSRQueryResponseCache = /*#__PURE__*/function (_RelayQueryResponseCa) {
  function SSRQueryResponseCache(_ref) {
    var _window, _window2;
    var _this;
    var cacheName = _ref.cacheName,
      size = _ref.size,
      ttl = _ref.ttl,
      timeoutCallback = _ref.timeoutCallback;
    _classCallCheck(this, SSRQueryResponseCache);
    _this = _callSuper(this, SSRQueryResponseCache, [{
      size: size,
      ttl: ttl
    }]);
    var isServer = typeof window === 'undefined';
    var cachedData = isServer ? {} : ((_window = window) === null || _window === void 0 || (_window = _window.SPA_STATE) === null || _window === void 0 ? void 0 : _window[cacheName]) || ((_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.SKELETON_NAVIGATION) === null || _window2 === void 0 ? void 0 : _window2[cacheName]) || {};
    _this.cacheName = cacheName;
    _this.requestMetadata = new Map(cachedData.requestMetadata);
    // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
    _this._responses = new Map(cachedData.responses);
    if (!isServer) {
      setTimeout(function () {
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        timeoutCallback === null || timeoutCallback === void 0 || timeoutCallback(_this._responses, _this.requestMetadata);
        // cleanup leftover data to reduce unnecessary memory usage
        _this.requestMetadata.clear();
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        _this._responses.clear();
      }, 60 * 1000 /* 1 minute */);
    }
    return _this;
  }

  /**
   * @deprecated only sets a single response; does not work well if requests use defer or stream.
   *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
   */
  _inherits(SSRQueryResponseCache, _RelayQueryResponseCa);
  return _createClass(SSRQueryResponseCache, [{
    key: "setWithMetadata",
    value: function setWithMetadata(queryID, variables, payload, metadata) {
      this.requestMetadata.set(queryID, metadata);
      this.set(queryID, variables, payload);
    }

    /**
     * Stores a GraphQLRepsonse along with metadata about the call.
     * If called multiple times (such as when incremental payloads are received),
     * will update the stored response to be an array of GraphQLSingularResponse objects,
     * which Relay is happy to handle.
     * @deprecated works, but does not work well if requests use defer or stream.
     *             use {@link appendWithMetadata} or, better still, use {@link "@atlassian/server-to-client-comms/server-dispatcher"}.
     */
  }, {
    key: "appendWithMetadata",
    value: function appendWithMetadata(queryID, variables, payload, metadata) {
      this.requestMetadata.set(queryID, metadata);
      var currentResponse = this.get(queryID, variables);
      if (!currentResponse) {
        this.set(queryID, variables, payload);
      } else if (currentResponse instanceof Array) {
        var newResponse = _toConsumableArray(currentResponse).concat(payload);
        this.set(queryID, variables, newResponse);
      } else {
        var _newResponse = [currentResponse].concat(payload);
        this.set(queryID, variables, _newResponse);
      }
    }

    /**
     * Deletes a request from the store, if found.
     *
     * IMPORTANT: Make sure DELETE method always has tests that include get/set
     * to ensure our `getCacheKey` matches Relay's.
     *
     * @returns {boolean} indicating if an entry in the cache was deleted
     */
  }, {
    key: "delete",
    value: function _delete(queryID, variables) {
      var cacheKey = getCacheKey(queryID, variables);
      // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
      return this._responses.delete(cacheKey);
    }
  }, {
    key: "serialize",
    value: function serialize() {
      return _defineProperty({}, this.cacheName, {
        // @ts-expect-error - TS2322 - Type '{ [x: string]: { requestMetadata: [string, RequestMetadata][]; responses: unknown[]; }; }' is not assignable to type 'Partial<Record<string, [string, GraphQLResponse][]>>'.
        requestMetadata: Array.from(this.requestMetadata.entries()),
        // @ts-expect-error - TS2339 - Property '_responses' does not exist on type 'SSRQueryResponseCache'.
        responses: Array.from(this._responses.entries())
      });
    }
  }]);
}(RelayQueryResponseCache);